import { fetchSimDocumentsToken } from "../../authentication/AuthenticationHelper";
import axios from "axios";

export interface PutModelApplicabilityParams {
    documentReference: string,
    productCompanyCode: string,
    models : string[]
}

export const PutModelApplicabilityAsync = async({
    documentReference,
    productCompanyCode,
    models
} : PutModelApplicabilityParams) => {
    const token = await fetchSimDocumentsToken();

    const body = {
        productCompanyCode: productCompanyCode,
        models: models.filter((e, i, self) => i === self.indexOf(e))
    };
    
    const config = {
        headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };

    await axios.put(
        `${process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL}/v1/SIMDocuments/Documents/${documentReference}/ChangeApplicabilityLevel`,
        body,
        config
    );
}